import api from './api';
import { BurpRequestResponse } from '../types';

export const burpService = {
  listPairs: async (params?: { schwachstelle_id?: number; audit_id?: number }): Promise<BurpRequestResponse[]> => {
    const response = await api.get('/burp/pairs', { params });
    return response.data;
  },

  getPair: async (id: number): Promise<BurpRequestResponse> => {
    const response = await api.get(`/burp/pairs/${id}`);
    return response.data;
  },

  getCombinedContent: async (id: number): Promise<string> => {
    const pair = await burpService.getPair(id);
    const parts: string[] = [];
    if (pair.request_raw) {
      parts.push(`=== REQUEST ===\n${pair.request_raw}`);
    }
    if (pair.response_raw) {
      parts.push(`=== RESPONSE ===\n${pair.response_raw}`);
    }
    return parts.join('\n\n') || '(kein Inhalt)';
  },
};
